import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CalendarHeader = ({ 
  currentDate, 
  viewMode, 
  onViewModeChange,
  onPreviousPeriod,
  onNextPeriod,
  onToday
}) => {
  const formatDateDisplay = () => {
    const options = { year: 'numeric', month: 'long' };
    if (viewMode === 'week') {
      const weekStart = new Date(currentDate);
      weekStart?.setDate(currentDate?.getDate() - currentDate?.getDay());
      const weekEnd = new Date(weekStart);
      weekEnd?.setDate(weekStart?.getDate() + 6);
      
      return `${weekStart?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} - ${weekEnd?.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })}`;
    } else if (viewMode === 'day') {
      return currentDate?.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
    }
    return currentDate?.toLocaleDateString('en-US', options);
  };

  const viewModes = [
    { id: 'month', label: 'Month', icon: 'calendar' },
    { id: 'week', label: 'Week', icon: 'calendar-days' },
    { id: 'day', label: 'Day', icon: 'calendar-check' }
  ];

  return (
    <div className="bg-card rounded-xl border border-border shadow-warm-sm p-4 md:p-6 mb-4 md:mb-6">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-3 md:gap-4">
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="icon"
              onClick={onPreviousPeriod}
              aria-label="←"
            >
              <Icon name="chevron-left" size={20} />
            </Button>
            
            <Button
              variant="outline"
              onClick={onToday}
              className="px-4 md:px-6"
            >
              Today
            </Button>
            
            <Button
              variant="outline"
              size="icon"
              onClick={onNextPeriod}
              aria-label="→"
            >
              <Icon name="chevron-right" size={20} />
            </Button>
          </div>
          
          <h2 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground">
            {formatDateDisplay()}
          </h2>
        </div>

        <div className="flex items-center gap-2 bg-muted rounded-lg p-1">
          {viewModes?.map((mode) => (
            <button
              key={mode?.id}
              onClick={() => onViewModeChange(mode?.id)}
              className={`flex items-center gap-2 px-3 md:px-4 py-2 rounded-md text-sm font-medium transition-all ${
                viewMode === mode?.id
                  ? 'bg-primary text-primary-foreground shadow-sm'
                  : 'text-muted-foreground hover:text-foreground hover:bg-background'
              }`}
              aria-label={`Switch to ${mode?.label} view`}
              aria-pressed={viewMode === mode?.id}
            >
              <Icon name={mode?.icon} size={16} />
              <span className="hidden md:inline">{mode?.label}</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CalendarHeader;